import * as React from 'react';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';

import * as colors from '../shared/colors';
import MessagesIcon from '../shared/components/icons/navIcons/MessagesIcon';
import MyPathsIcon from '../shared/components/icons/navIcons/MyPathsIcon';
import NavArrow from '../shared/components/icons/navIcons/NavArrow';
import ProfileIcon from '../shared/components/icons/navIcons/ProfileIcon';
import { loadJSData } from '../shared/jsData';
import t from '../shared/translations';
import { useCurrentPerson } from './components/CurrentPerson';
import Messages from './messages/Messages';
import MyHistory from './myHistory/MyHistory';
import Profile from './profile/Profile';

const Wrapper = styled.main`
    padding: 0 15px;
    flex-grow: 1;
    max-width: 1440px;
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
        flex-direction: row;
    }
`;

const Nav = styled.nav`
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    @media (min-width: 768px) {
        flex-direction: column;
        width: 270px;
    }
`;

const StyledNavLink = styled(NavLink)`
    padding: 10px;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: -1px;
    margin-left: -1px;
    flex-direction: column;
    font-size: 0.9rem;
    color: ${colors.text};
    border: 1px solid lightgray;
    display: flex;
    align-items: center;
    z-index: 1;

    &:first-child {
        margin-left: 0px;
    }
    &.active {
        border-bottom-color: white;
    }

    &:active, &:hover, &:visited {
        color: ${colors.text};
    }

    @media (min-width: 768px) {
        flex-direction: row;
        padding: 2rem 10px;
        position: relative;
        font-size: 1.1rem;
        margin-right: -1px;
        margin-top: -1px;

        & > span {
            flex-grow: 1;
            padding-left: 0.5rem;
        }
        &:first-child {
            margin-top: 0px;
        }

        &.active {
            border-right-color: white;
            border-bottom-color: lightgray;
        }
    }

    .nav-icon {
        width: 50px;
        height: 50px;
        fill: ${colors.unlight};

        text {
            fill: ${colors.white};
            stroke: ${colors.white};
            font-family: 'Proxima Nova', sans-serif;
            font-size: 1.5rem;
            text-anchor: middle;
        }
    }
`;

const StyledNavArrow = styled(NavArrow)`
    display: none;
    @media (min-width: 768px) {
        display: block;
        width: 14px;
        height: 14px;
        fill: ${colors.unlight};
    }
`;

function NavBar(): JSX.Element {
    const person = useCurrentPerson();
    return <Nav>
        <StyledNavLink to='../my-history'>
            <MyPathsIcon />
            <span>{t('player.profile-nav.my-history', { webapp_title: loadJSData().settings.title })}</span>
            <StyledNavArrow />
        </StyledNavLink>
        <StyledNavLink to='../profile'>
            <ProfileIcon />
            <span>{t('player.profile-nav.profile')}</span>
            <StyledNavArrow />
        </StyledNavLink>
        <StyledNavLink to='../messages'>
            <MessagesIcon unread={person.unreadMessages} />
            <span>{t('player.profile-nav.messages')}</span>
            <StyledNavArrow />
        </StyledNavLink>
    </Nav>;
}

function ProfileNav(): JSX.Element {
    return <Wrapper>
        <Routes>
            <Route path='my-history' element={<>
                <NavBar />
                <MyHistory />
            </>} />
            <Route path='profile' element={<>
                <NavBar />
                <Profile />
            </>} />
            <Route path='messages/*' element={<>
                <NavBar />
                <Messages />
            </>} />
            <Route path='/' element={<Navigate to='my-history' />} />
        </Routes>
    </Wrapper>;
}

export default ProfileNav;
